// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddToGroupDialogComponent } from './components/add-to-group-dialog/add-to-group-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CreateGroupModule } from '@coa/app/shared/add-to-group-dialog/modules/create-group/create-group.module';
import { AddToGroupModule } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/add-to-group.module';
import { CustomSnackbarModule } from '@coa/app/shared/add-to-group-dialog/modules/custom-snackbar/custom-snackbar.module';
import { CuiButtonModule } from '@coa/app/shared/button/button.module';

@NgModule({
  declarations: [
    AddToGroupDialogComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    AddToGroupModule,
    CreateGroupModule,
    CustomSnackbarModule,
    CuiButtonModule,
  ],
})
export class AddToGroupDialogModule {
}
